module.exports = __webpack_public_path__ + "static/media/LK.a8d42610.svg";